/*! 
 * (C)Mynavi Corporation
 * 下層ページ用の処理
 */

var MNL = MNL || {};
import jQuery from 'jquery';
const $ = jQuery;

/** ============================================================
 * 新着のお知らせ
 * ========================================================== */
/** ------------------------------
 * 要素が3つ以上あった場合に非表示に
 * 矢印がクリックされたら非表示要素を表示
 * ---------------------------- */
MNL.itemShow = function () {

  var elSlideList = document.querySelectorAll('.js--sd__block');

  /* NodeList.prototype.forEachが使えないIEなどへの配慮 */
  if (!NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  // 初期値
  elSlideList.forEach(function (element, i) {
    var childElementCount = element.childElementCount ;
    if(childElementCount > 3){
      itemShowTgl(element, i);
    }
  });

  // 開閉ボタンクリック時
  var targets = document.getElementsByClassName('js--sd__btn');
  for(let i = 0; i < targets.length; i++){
    targets[i].addEventListener('click', () => {
      itemShowTgl(elSlideList[i], i);
    }, false);
  }


  function itemShowTgl(element, i) {

    var show_height = 0;
    var item = element.children;
    for (var num = 0; num < 3; num++){
      show_height = show_height + item[num].clientHeight;
    }

    // 初期値
    var sdBlockDisp = show_height + 'px';
    var sdBtnRemoveClass = 'p--show__btn--open';
    var sdBtnAddClass = 'p--show__btn--close';

    // クリックで中身が閉じている場合
    if(document.getElementsByClassName('js--sd__btn')[i].classList.contains('p--show__btn--close') == true){
      var sdBlockDisp = 'auto';
      var sdBtnRemoveClass = 'p--show__btn--close';
      var sdBtnAddClass = 'p--show__btn--open';
    }

    document.getElementsByClassName('js--sd__block')[i].style.height =  sdBlockDisp;
    document.getElementsByClassName('js--sd__btn')[i].classList.remove(sdBtnRemoveClass);
    document.getElementsByClassName('js--sd__btn')[i].classList.add(sdBtnAddClass);

  }


}


/** ============================================================
 * お気に入り
 * ========================================================== */
/** ------------------------------
 * 表示トグル
 * すべて閉じる、開くで全体のトグルを変更
 * ---------------------------- */
MNL.itemToggle = function () {

  var elTglBlock = document.getElementsByClassName('js--tgl__block');
  var elTglList = document.getElementsByClassName('js--tgl__allBtn');

  var elTglHead = document.getElementsByClassName('js--tgl__head');
  var elTglBody = document.getElementsByClassName('js--tgl__body');

  for(let i = 0; i < elTglHead.length; i++){
    var itemOpen = elTglHead[i].classList.contains('p--tgl--open');
    if(itemOpen == true){
      elTglBody[i].style.display = 'block';
    }else{
      elTglBody[i].style.display = 'none';
    }
  }

  // すべて開く / 閉じる
  for(let i = 0; i < elTglList.length; i++){
    elTglList[i].addEventListener('click', () => {
      var tglSwitch = elTglList[i].dataset.all;

      if(tglSwitch == 'close'){
        // ボタン切り替え
        elTglList[i].textContent = "すべて開く";
        elTglList[i].dataset.all = 'open';

        // ボタンクラスを外して要素を隠す
        for (var num = 0; num < elTglHead.length; num++){
          // $(elTglBody[num]).stop().slideUp();
          elTglHead[num].classList.remove('p--tgl--open');
          elTglBody[num].style.display = 'none';
        }
      } else {
        // ボタン切り替え
        elTglList[i].textContent = "すべて閉じる";
        elTglList[i].dataset.all = 'close';

        // ボタンクラスを付与して要素を表示
        for (var num = 0; num < elTglHead.length; num++){
          // $(elTglBody[num]).stop().slideDown();
          elTglHead[num].classList.add('p--tgl--open');
          elTglBody[num].style.display = 'block';
        }
      }
    }, false);
  }

  // 個別のクリック
  for(let i = 0; i < elTglHead.length; i++){
    elTglHead[i].addEventListener('click', (obj) => {

      // aタグの時は開閉させない
      if(obj.target.tagName == 'A'){
        return false;
      }

      // 現在要素が開いているか
      var bodyState = elTglHead[i].classList.contains('p--tgl--open');

      /*
       * 20200427
       * 修正依頼により開閉時スライド処理に変更。元から記載してあったJQのslide系をアクティブにして書き出し
       */
      if(bodyState == false){
        $(elTglBody[i]).stop().slideDown();
        elTglHead[i].classList.add('p--tgl--open');
      }else{
        $(elTglBody[i]).stop().slideUp();
        elTglHead[i].classList.remove('p--tgl--open');
      }

      var openNum = elTglBody[i].parentNode.getElementsByClassName('p--tgl--open').length;

      for(let i = 0; i < elTglList.length; i++){
        if(openNum == 0) {
          elTglList[i].textContent = "すべて開く";
          elTglList[i].dataset.all = 'open';
        }else{
          elTglList[i].textContent = "すべて閉じる";
          elTglList[i].dataset.all = 'close';
        }
      }

    }, false);
  }

}


/** ============================================================
 * プレビュー
 * ========================================================== */
/** ------------------------------
 * 表示トグル
 * 閉じる、もっと見るでトグルを変更
 * ---------------------------- */
MNL.singleItemToggle = function () {

  var elMoreTglBlock = document.getElementsByClassName('js--tgl__more');
  var elMoreTglBody = document.getElementsByClassName('js--tgl__more--body');
  var elMoreTglBtn = document.getElementsByClassName('js--tgl__moreBtn');
  var moreBtnTxt = "もっと見る";

  // 一定の高さ以上ある場合は開閉htmlを追加する
  for(let i = 0; i < elMoreTglBlock.length; i++){

    // テキスト要素の高さを取得
    var textHeight = elMoreTglBody[i].clientHeight;
    // テキスト要素のline-heightを取得
    var lineHeight = getComputedStyle(elMoreTglBody[i]).getPropertyValue('line-height');
    lineHeight = lineHeight.replace(/[^-\d\.]/g, ''); //pxの削除
    // 箱のpadding上下取得

    var pdTop = getComputedStyle(elMoreTglBody[i].firstElementChild).paddingTop;
    var pdBtm = getComputedStyle(elMoreTglBody[i].firstElementChild).paddingBottom;
    pdTop = pdTop.replace(/[^-\d\.]/g, ''); //pxの削除
    pdBtm = pdBtm.replace(/[^-\d\.]/g, ''); //pxの削除

    var setItemHeight = textHeight - pdTop - pdBtm;
    var setLineHeight = lineHeight * 3;

    if(elMoreTglBlock[i].classList.contains('js--tgl__more--splitBox')){
      setLineHeight = lineHeight * 9;
      if (window.mnstate.isMobile == true) {
        setLineHeight = lineHeight * 5;
      }
      setItemHeight = textHeight;
    }

    if(setItemHeight > setLineHeight){
      elMoreTglBody[i].classList.add('c--tgl__body--more');

      if(elMoreTglBlock[i].classList.contains('c--tgl--open') == true){
        moreBtnTxt = "閉じる";
      }else{
        moreBtnTxt = "もっと見る";
      }

      var addHtml = '<div class="c--moreBtn__block">'
                    + '<p class="js--tgl__moreBtn c--tgl__moreBtn" data-btn_num="' + i + '"><span>' + moreBtnTxt + '</span></p>'
                    + '</div>';
      elMoreTglBody[i].insertAdjacentHTML('beforeend', addHtml);
    }

    elMoreTglBlock[i].style.opacity = 1;
  }

  // 個別のクリック
  for(let i = 0; i < elMoreTglBtn.length; i++){

    elMoreTglBtn[i].addEventListener('click', (obj) => {

      // 現在要素が開いているか
      var bodyState = elMoreTglBtn[i].parentNode.parentNode.parentNode.classList.contains('c--tgl--open');

      // 開閉するアイテムの数値取得
      var target = elMoreTglBtn[i].dataset.btn_num;

      if(bodyState == false){
        elMoreTglBlock[target].classList.add('c--tgl--open');
        elMoreTglBtn[i].firstElementChild.textContent = "閉じる";
      }else{
        elMoreTglBlock[target].classList.remove('c--tgl--open');
        elMoreTglBtn[i].firstElementChild.textContent = "もっと見る";
      }

    }, false);
  }
}



/** ============================================================
 * MENU-002_login.html
 * ========================================================== */
/** ------------------------------
 * n件以上の場合は非表示、もっと見るで要素をn件ずつ追加
 * ---------------------------- */
// MNL.moreAddBlock = function () {
//   var showNum = "20"; //初期最低値
//   var addShowNum = "10"; //「もっと見る」で追加される数
//   var moreBlock = document.getElementsByClassName('js--moreAdd__block');
//   var moreAddBtn = document.getElementsByClassName('js--moreAdd__btn');

//   // showNum以上件数がある場合は数以降を非表示にする
//   for(let i = 0; i < moreBlock.length; i++){
//     var moreItem = moreBlock[i].getElementsByClassName('js--moreAdd__item');

//     if(moreItem.length > 0 && moreItem.length > showNum){
//       for(let i = 0; i < moreItem.length; i++){
//         if(i >= showNum){
//           moreItem[i].style.display ="none";
//         }
//       }
//       var addHtml = '<p class="u--txtal__center p--top__btn">'
//       + '<span class="js--moreAdd__btn c--btn c--btn--w c--color--p80 c--btn--noTxtShadow">もっと見る</span>'
//       + '</p>';
//       moreBlock[i].insertAdjacentHTML('beforeend', addHtml);
//     }
//   }

    
//   // 個別のクリック
//   for(let i = 0; i < moreAddBtn.length; i++){

//     moreAddBtn[i].addEventListener('click', () => {

//       var moreAddItemNum = parseInt(showNum) + parseInt(addShowNum);

//       for(let i = 0; i < moreBlock.length; i++){
//         var moreItem = moreBlock[i].getElementsByClassName('js--moreAdd__item');
//         if(moreItem.length > 0){
//           for(let i = 0; i < moreItem.length; i++){
//             if(i >= moreAddItemNum){
//               moreItem[i].style.display ="none";
//             }else{
//               moreItem[i].style.display ="block";
//             }
//           }
//         }
//         if(moreAddItemNum > moreItem.length){
//           moreBlock[i].getElementsByClassName('js--moreAdd__btn')[0].style.display ="none";
//         }
//       }

//       addShowNum = parseInt(moreAddItemNum) + parseInt(addShowNum) - parseInt(showNum);

//     }, false);
//   }
// }


/** ============================================================
 * パスワードの可視化
 * ========================================================== */
/**
 * パスワードの可視化
 */
require('hideshowpassword');
MNL.chkPassword = function () {
  $('.js--password').hideShowPassword({
    show: false, // パスワード可視の有無
    innerToggle: true, // トグルボタンを入力欄に設置するかの有無
  });
}



/* ////////////////////////////////////////////////////////////////////////////////////////// */
/* ////////////////////////////////////////////////////////////////////////////////////////// */
/** ============================================================
 * 要素が全て読み込まれたときの処理
 * ========================================================== */
window.addEventListener( 'load', function(){
  MNL.itemShow(); // 初期設定で要素非表示
  MNL.itemToggle(); // 個別・全体トグル
  MNL.singleItemToggle(); // 個別のみ対応トグル
  // MNL.moreAddBlock(); //もっと見るで要素を表示
  MNL.chkPassword(); // パスワード目のアイコン
}, false);